import footerBg from "@/assets/footer-bg.jpg";
import hingeScreenshots from "@/assets/hinge-screenshots.png";
import swingersDate from "@/assets/swingers-date.png";
import japanTrip from "@/assets/japan-trip.png";
import osakaKanazawa from "@/assets/osaka-kanazawa.png";
import japanFood from "@/assets/japan-food.png";
import francisPointSunset from "@/assets/francis-point-sunset.png";
import engagementShoot from "@/assets/engagement-shoot.png";
import travelSteamer from "@/assets/travel-steamer.png";
import parentsMeeting from "@/assets/parents-meeting.png";
import bostonParty from "@/assets/boston-party.png";
import happyDog from "@/assets/happy-dog.png";

const polaroid = "polaroid mt-8 bg-white p-3 pb-8 shadow-md border border-neutral-300 rounded";

export function Story() {
  return (
    <div className="min-h-screen bg-background">
      <article className="pt-24 md:pt-32 pb-20 mx-auto px-6 max-w-175">
        <h1 className="font-display text-4xl text-foreground text-center mb-12">Story</h1>

        <h2 className="font-display text-xl md:text-2xl text-foreground mb-6">
          A trash bag starts it all...
        </h2>
        <p className="text-muted-foreground leading-relaxed text-lg mb-8">
          "Soooo when are you gonna take out the trash?". Those were the only nine words Andrew needed to know that Jamie was the one. Sunday night at 7pm, Swingers mini-golf in Midtown Manhattan – it was a date.
        </p>
        <img
          src={hingeScreenshots}
          alt="Jamie and Andrew's Hinge profiles and first message"
          className="w-full rounded-lg mb-8"
        />
        <p className="text-muted-foreground leading-relaxed text-lg">
          Jamie came into the date feeling nauseous. It was her second ever Hinge date, and the nerves were hitting big time. Andrew bought her a Moscow Mule, and she promptly downs the entire drink on the first hole. This left Andrew a bit concerned, but they continued anyways. As the night went on, it became apparent that the Yangs were appropriately named. Sometimes, you just know.
        </p>
        <figure className={polaroid} style={{ transform: "rotate(1.2deg) translate(8px, -4px)" }}>
          <img src={swingersDate} alt="Jamie and Andrew at Swingers mini-golf" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Swingers 4/9/2023 (with a lil photoshop)
          </figcaption>
        </figure>

        <h2 className="font-display text-xl md:text-2xl text-foreground mt-16 mb-6">
          Land of the rising love 🧀
        </h2>
        <p className="text-muted-foreground leading-relaxed text-lg">
          Around six months after their first date, Jamie and Andrew decide to take their first trip together. It wasn't just a trip to nearby Connecticut or Alabama – they decided to send it on a two week trip to Japan. Those were the two weeks where Jamie and Andrew fell in love. Hey, if you spend every waking moment with another person for two weeks straight and that's still not enough, then what else could it be?
        </p>
        <figure className={polaroid} style={{ transform: "rotate(-1.8deg) translate(-12px, -8px)" }}>
          <img src={japanTrip} alt="Andrew biking in Kyoto and sunset in Nara" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Andrew learning to bike in Kyoto & 11/10 sunset in Nara
          </figcaption>
        </figure>
        <figure className={polaroid} style={{ transform: "rotate(1deg) translate(4px, 4px)" }}>
          <img src={osakaKanazawa} alt="Ratchet nights in Osaka and wholesome evenings in Kanazawa" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Halloween in Osaka & wholesome Kanazawa evenings
          </figcaption>
        </figure>
        <figure className={polaroid} style={{ transform: "rotate(-1.5deg) translate(-8px, 4px)" }}>
          <img src={japanFood} alt="Jamie and Andrew's food adventures in Japan" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Sushi, Omurice, Chankonabe, Tempura, Melon pan...
          </figcaption>
        </figure>

        <h2 className="font-display text-xl md:text-2xl text-foreground mt-16 mb-6">
          She said 好吧
        </h2>
        <p className="text-muted-foreground leading-relaxed text-lg">
          The pressure was on. With the ring stuffed deep into his backpack, and his suitcase secretly overflowing with their photoshoot outfits (complete with a travel steamer), Andrew nervously makes his way through TSA at Newark. "Please god do not let them open my bag". The deities were with him on that day, and they made it onto their flight to Vancouver with their bags untouched.
        </p>
        <p className="text-muted-foreground leading-relaxed text-lg mt-4">
          A perfect weekend in Vancouver and a ferry ride to remote Sunshine Coast later, everything was going according to plan. On July 14, 2025, Jamie said yes, and got engaged to her second ever Hinge date!
        </p>
        <figure className={polaroid} style={{ transform: "rotate(2deg) translate(12px, -4px)" }}>
          <img src={francisPointSunset} alt="Jamie and Andrew showing engagement ring at Francis Point Provincial Park during sunset" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Francis Point Provincial Park during sunset 💍
          </figcaption>
        </figure>
        <figure className={polaroid} style={{ transform: "rotate(-1.2deg) translate(-4px, -8px)" }}>
          <img src={engagementShoot} alt="Jamie and Andrew's engagement shoot in a field of flowers" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Engagement shoot in a field of flowers 🍊
          </figcaption>
        </figure>
        <figure className={polaroid} style={{ transform: "rotate(1.7deg) translate(8px, 4px)" }}>
          <img src={travelSteamer} alt="Jamie and Andrew sitting in a field of flowers during engagement shoot" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            That travel steamer came in handy
          </figcaption>
        </figure>
        <p className="text-muted-foreground leading-relaxed text-lg mt-8">
          Andrew had one more surprise up his sleeve. "BOSTON?!" Jamie exclaimed as she checked into her flight. After emailing Jamie fake tickets back to New York, Andrew actually booked their return flight to Boston, her hometown. Andrew's parents would also be there to greet them. Both Jamie and Andrew would agree that one of the best parts of their engagement was seeing their parents meet, and celebrating together with their family (and their dog Happy 🐶).
        </p>
        <figure className={polaroid} style={{ transform: "rotate(-1.3deg) translate(-12px, -4px)" }}>
          <img src={parentsMeeting} alt="Jamie and Andrew's parents meeting for the first time at a Chinese restaurant" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            The rents meeting for the first time
          </figcaption>
        </figure>
        <figure className={polaroid} style={{ transform: "rotate(1.4deg) translate(4px, -8px)" }}>
          <img src={bostonParty} alt="Jamie and Andrew celebrating their engagement with aunties and uncles in Boston" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Party with the aunties and uncles 🍾
          </figcaption>
        </figure>

        <h2 className="font-display text-xl md:text-2xl text-foreground mt-16 mb-6">
          8.28.2026 ❤️
        </h2>
        <p className="text-muted-foreground leading-relaxed text-lg">
          We can't wait to celebrate with you all! Thanks so much for taking the time to be with us on this day.
        </p>
        <figure className={polaroid} style={{ transform: "rotate(-1.6deg) translate(-8px, -4px)" }}>
          <img src={happyDog} alt="Happy the dog eagerly waiting to meet you at the wedding venue" className="w-full" />
          <figcaption className="text-muted-foreground text-base italic text-center mt-4">
            Happy is eagerly waiting to meet you!
          </figcaption>
        </figure>
      </article>
      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
